export default {
  title: 'Drikkepengeindstillinger',
  form: {
    has_tips: {
      label: 'Tillad drikkepenge',
    },
    default_tip_percentage: {
      label: 'Forudvalgt drikkepengesats',
      tooltip: 'Denne sats forudvælges for kunden, når vedkommende når til betalingsskærmen',
    },
    is_tip_hidden_on_receipt: {
      label: 'Skjul drikkepenge på kvitteringer',
      tooltip: 'Når dette er slået til, skjules drikkepenge både på udskrevne kvitteringer og i ordreinfovinduet',
    },
  },
  buttons: {
    save: 'Gem',
  },
  toasts: {
    failed_to_save_changes: 'Ændringerne kunne ikke gemmes',
    changes_got_saved: 'Ændringerne er gemt',
  },
};
